export { default as Part } from './generic-part-input';
